import { Route } from 'react-router-dom';
import { mandatSchema } from './mandat';
import Main from '@app/main/tables/Main';
import { parrainageSchema } from '../Parrainage/parrainage';
import { commandeSchema } from '../Commande/commande';
import MandatDetails from './MandatDetails';

/**
 * Routes configurées pour le module Mandat
 */
const MandatRoutes = [
    // Route de liste (principale)
    <Route
        key="mandats-list"
        path="mandats"
        element={<Main key="mandats-main" pageConfig={mandatSchema} />}
    />,

    // Route détaillée pour un mandat spécifique
    <Route
        key="mandats-details"
        path="mandats/:id/details"
        element={<MandatDetails />}
    />,

    // route pour afficher les parrainages d'un mandat
    <Route
        key="mandats-parrainages"
        path="mandats/:id/parrainages"
        element={
            <Main key="parrainages-from-mandat" pageConfig={parrainageSchema} />
        }
    />,

    // route pour afficher les commandes d'un mandat
    <Route
        key="mandats-commandes"
        path="mandats/:id/commandes"
        element={
            <Main key="commandes-from-mandat" pageConfig={commandeSchema} />
        }
    />,
];

export default MandatRoutes;
